// extracted by mini-css-extract-plugin
export default {"Container":"events_Container__J7JXa","HeroImage":"events_HeroImage__WLZcA","Description":"events_Description__OpXC-","FormDescription":"events_FormDescription__52uwe"};